/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useCallback, useMemo, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import IconButton from '../../../common/icon-button/icon-button';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '../../../common/popover/popover.component';
import { ReactComponent as MeestPortalLogo } from '../../../assets/meest-products/meest-portal-logo.svg';
import { ReactComponent as MeestShoppingLogo } from '../../../assets/meest-products/meest-shopping-logo.svg';
import {
  CrossSaleContainer,
  CrossSaleMenuContainer,
  CrossSaleMenuItem,
} from './styles';
import { Dropdown } from '../../../common/dropdown/dropdown.styles';
import { useIsMobile } from '../../../hooks/use-is-mobile.hook';
import BottomSidebar from '../../../common/sidebar-bottom/bottom-sidebar.component';
import { useStore } from '../../../stores/store';
import { Modals } from '../../../constants/modals';
import { generateLocaleRoute } from '../../../utils/uri/uri.utils';

const CrossSaleMenu = () => {
  const {
    navStore: { toggleSidebarByName },
    modalStore: { open, close },
  } = useStore();

  const navigate = useNavigate();

  const openModalHandler = useCallback(() => {
    open({
      id: Modals.CROSS_SALE,
      name: Modals.CROSS_SALE,
      props: {
        onClose: () => {
          close(Modals.CROSS_SALE);
        },
      },
    });
  }, [open, close]);

  const isMobile = useIsMobile();
  const [isMenuOpened, setIsMenuOpened] = useState(false);

  const toggleMenu = useCallback(() => {
    if (isMobile) {
      toggleSidebarByName('cross-sale-menu-mobile');
    } else {
      setIsMenuOpened((prev) => !prev);
    }
  }, [isMobile, toggleSidebarByName]);

  const CrossSaleItems = useMemo(
    () => [
      {
        icon: <MeestPortalLogo />,
        text: 'Meest Portal',
        url: generateLocaleRoute(),
        clickHandler: () => {
          toggleMenu();
        },
      },
      {
        icon: <MeestShoppingLogo />,
        text: 'Meest Shopping',
        clickHandler: () => {
          openModalHandler();
          toggleMenu();
        },
      },
    ],
    [toggleMenu, openModalHandler]
  );

  const triggerButton = (
    <IconButton
      icon={{ glyph: 'waffle-menu' }}
      onClick={() => toggleMenu()}
      appearance='text'
      size='large'
    />
  );

  const menu = (
    <CrossSaleMenuContainer>
      {CrossSaleItems.map((x) => (
        <CrossSaleMenuItem
          key={x.text + x.url}
          {...(x.url ? { as: Link, to: x.url } : {})}
          type='button'
          onClick={() => x.clickHandler()}>
          <span className='menuItemIcon'>{x.icon}</span>
          <p className='menuItemText'>{x.text}</p>
        </CrossSaleMenuItem>
      ))}
    </CrossSaleMenuContainer>
  );

  const desktopContent = (
    <Popover
      initialOpen={false}
      open={isMenuOpened}
      onOpenChange={toggleMenu}
      placement='bottom-end'>
      <PopoverTrigger asChild>{triggerButton}</PopoverTrigger>
      <PopoverContent>
        <Dropdown $width='23.5rem'>{menu}</Dropdown>
      </PopoverContent>
    </Popover>
  );

  const mobileContent = (
    <>
      {triggerButton}
      <BottomSidebar
        mobPadding='1.6rem 1.6rem 3.2rem 1.6rem'
        name='cross-sale-menu-mobile'
        withBlurredBackground>
        {menu}
      </BottomSidebar>
    </>
  );

  const content = isMobile ? mobileContent : desktopContent;

  return <CrossSaleContainer>{content}</CrossSaleContainer>;
};

export default CrossSaleMenu;
